"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandContext = void 0;
const LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider/LocalizationProvider");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const material_1 = require("@mui/material");
const Calendar_1 = __importDefault(require("./Calendar"));
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const ahoyMui_1 = __importDefault(require("./themes/ahoyMui"));
const floatspaceMui_1 = __importDefault(require("./themes/floatspaceMui"));
exports.BrandContext = react_1.default.createContext(null);
function widget(props) {
    const [widgetData, setWidgetData] = (0, react_1.useState)(null);
    const [brandData, setBrandData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        getWidgetData();
    }, []);
    const getWidgetData = () => {
        const params = new URLSearchParams();
        params.append("brandId", props.brandId);
        const baseUrl = "/api/widget/index/" + props.uuid;
        axios_1.default
            .get(baseUrl, {
            params: params,
        })
            .then((response) => {
            setWidgetData(response.data);
            console.log('brand', response.data.brand);
            setBrandData(response.data.brand);
        })
            .catch((error) => {
            const data = { valid: false, brand: { id: "", key: "", name: "", termsUrl: "" } };
            setWidgetData(data);
        });
    };
    let appTheme = (0, material_1.createTheme)(ahoyMui_1.default);
    if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.valid) {
        if ((widgetData === null || widgetData === void 0 ? void 0 : widgetData.brand.key) === "floatspace") {
            appTheme = (0, material_1.createTheme)(floatspaceMui_1.default);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (widgetData === null || widgetData === void 0 ? void 0 : widgetData.valid) === false && react_1.default.createElement(material_1.Typography, null, "Boat Not Found"),
        (widgetData === null || widgetData === void 0 ? void 0 : widgetData.valid) && (react_1.default.createElement(material_1.ThemeProvider, { theme: appTheme },
            react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                react_1.default.createElement(exports.BrandContext.Provider, { value: brandData },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(Calendar_1.default, { uuid: props.uuid, brandId: props.brandId })))))))));
}
exports.default = widget;
